export default __webpack_public_path__ + "static/media/organisation.39fb5de6.png";